(ns practitest.frontend.components2.dashboard.transforms.gauge
  (:require [practitest.frontend.components2.dashboard.schema :as sc]
            [practitest.frontend.common.i18n :refer [format-translation get-translation]]
            [clojure.string :as str]))

(def Level
  [:enum :low :medium :high])

(def GaugeLegendItem
  [:map
   [:level Level]
   [:label :string]
   [:range :string]])

(def GaugeData
  [:map
   [:value number?]
   [:level Level]
   [:display-value :string]
   [:label :string]
   [:status-label :string]
   [:scale-labels [:tuple :string :string]]
   [:legend [:sequential GaugeLegendItem]]])

(def GaugeChartTransformed
  [:map
   [:chart/data {:optional true} GaugeData]])

(defn- score->status
  [percent {:keys [low medium]}]
  (condp <= percent
    medium :high
    low    :medium
    :low))

(defn- status-label [level]
  (case level
    :low    (get-translation "dashboard-item.form.gauge-off-track" "Off Track")
    :medium (get-translation "dashboard-item.form.gauge-at-risk" "At Risk")
    :high   (get-translation "dashboard-item.form.gauge-on-track" "On Track")
    nil))

(defn- legend-items
  [{:keys [low medium]}]
  (for [[level range] [[:low    (str "<" low "%")]
                       [:medium (str low "–" medium "%")]
                       [:high   (str "≥" medium "%")]]]
    {:level level
     :label (status-label level)
     :range range}))

(defn- prepare-data
  [{{{:keys [percentage count total]} :value
     :keys                          [thresholds]} :chart/data
    :chart/keys                                   [entity-name]}]
  (let [percent (Math/round (* percentage 100))
        level   (score->status percent thresholds)
        label   (str (format-translation
                       (get-translation "dashboards.gauge.count-of-total" "%{count} of %{total}")
                       :count  count
                       :total  total)
                     " "
                     (str/lower-case entity-name))]
    {:value         percentage
     :level         level
     :display-value (str percent "%")
     :label         label
     :status-label  (status-label level)
     :scale-labels  ["0%" "100%"]
     :legend        (legend-items thresholds)}))

(defn transform
  {:malli/schema [:=> [:cat sc/GaugeChart]
                  GaugeChartTransformed]}
  [{:chart/keys [data] :as chart}]
  (cond-> chart
    data (assoc :chart/data (prepare-data chart))))
